export default __webpack_public_path__ + "static/media/action-pause_lightGray1.8a3f7e98.svg";